<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid class="fill-height">
        <v-row class="flex-child fill-height" style="max-width: none;">
            <v-col cols="12" md="3">
                <v-sheet class="fill-height" elevation="2">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-chip class="ma-2 Headline" color="primary">
                                <!-- //组织预览 -->
                                {{ $vuetify.lang.t('$vuetify.custom.org.orgPreview') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="my-4" justify="center">
                        <v-col cols="12" md="10">
                            <e-tree :active="active" :overlay="overlay" :open="openData" :items="items"
                                    :openOnClick="openOnClick" @selectedVal="selectOrg"></e-tree>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="9">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-chip class="ma-2 Headline" color="success">
                            {{ $vuetify.lang.t('$vuetify.custom.user.user') }}
                        </v-chip>
                        <v-card>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="搜索"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-col>
                                <v-row justify="end" class="my-4">
                                    <v-btn color="success mr-3" @click="titledillog" dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.userBindAdd') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-data-table
                                    :headers="headers"
                                    :items="desserts"
                                    :search="search"
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn color="normal" class="mr-2" x-small @click="deleteItem(item)">
                                            <v-icon small>
                                                mdi-delete
                                            </v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.deleteBind') }}
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div class="text-center">
            <v-dialog
                v-model="binddialog"
                width="500"
                persistent
            >
                <userBinddialog v-model="binddialog" :orgId="orgId" ref="child"
                                @initialize="initialize"></userBinddialog>
            </v-dialog>
        </div>


    </v-container>
</template>
<style></style>
<script>
import IconSelector from '@/components/icon/IconSelector'
import ETree from '@/components/tree/ETree'
import Mock from 'mockjs'
import userBinddialog from './userBinddialog'

export default {
    data() {
        return {
            //文本操作状态   可用作图标的显示
            textDisabled: true,
            //操作区按钮
            buttonsDisabled: true,
            //保存按钮
            saveDisabled: true,
            //是修改还是添加
            isUpdate: true,
            search: '',

            headers: [
                {
                    text: '用户名',
                    align: 'start',
                    sortable: false,
                    value: 'userName',
                    width: '300',
                },
                {text: '真实姓名', value: 'realName'},
                {text: '创建时间', value: 'createTime'},
                {text: '创建人', value: 'creator'},
                {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
            ],
            desserts: [],

            label: {
                name: this.$vuetify.lang.t('$vuetify.custom.org.orgName'),//'组织名称',
                code: this.$vuetify.lang.t('$vuetify.custom.org.orgCode'),//'组织编码',
                order: this.$vuetify.lang.t('$vuetify.custom.org.orgOrder'),//'组织排序码',
                update: this.$vuetify.lang.t('$vuetify.custom.org.updateOrg'),//'修改组织',
                delete: this.$vuetify.lang.t('$vuetify.custom.org.deleteOrg'),//'删除组织',
                add: this.$vuetify.lang.t('$vuetify.custom.org.addPeer'),//'新增同级',
                addSub: this.$vuetify.lang.t('$vuetify.custom.org.addSubset'),//'新增子集',
                icon: this.$vuetify.lang.t('$vuetify.custom.icon'),//'图标',
                img: this.$vuetify.lang.t('$vuetify.custom.image'),//'图片',
                save: this.$vuetify.lang.t('$vuetify.custom.preservation'),//'保存',
                cancel: this.$vuetify.lang.t('$vuetify.custom.cancelBtn'),//'取消',
                file: this.$vuetify.lang.t('$vuetify.custom.pleaseSelectImageFile'),//'请选择图像文件',
                addMenu: this.$vuetify.lang.t('$vuetify.custom.menu.menuOperation'),//'菜单操作',
                cancelOperation: this.$vuetify.lang.t('$vuetify.custom.giveUpOperation'),//'放弃操作'
                updateSuccess: this.$vuetify.lang.t('$vuetify.custom.updateSuccess'),//修改成功
                addSuccess: this.$vuetify.lang.t('$vuetify.custom.addSuccess'),//添加成功
            },
            items: [],
            itemsOld: [],
            formData: {
                id: '',
            },
            rules: {
                required: value => !!value || this.$vuetify.lang.t('$vuetify.custom.pleaseEnery')
            },
            orgRules: [value => (!!value && value <= 9999 && value >= 0) || this.$vuetify.lang.t('$vuetify.custom.org.orgOrderDesc')],
            file: {},
            openOnClick: false,
            overlay: false,
            active: [],
            result: [],
            openData: [],
            preIcon: '',
            binddialog: false,
            orgId: '001',
        }
    },
    created() {
        this.loadOrganization();
        this.selectOrg();
    },
    mounted() {
    },
    computed: {
        iconShow(icon) {
            return function (icon) {
                if (icon.length == 32) {
                    return this.$file.fileDownload(icon)
                }
                return icon
            }
        },
    },
    methods: {
        initialize() {
            this.binddialog = false;
            this.loadOrganization();
            this.selectOrg();
        },
        titledillog() {
            this.binddialog = true;
            if (this.$refs.child != undefined) {
                this.$refs.child.getTree();
                this.$refs.child.listRole();
            }
        },
        //查询组织树形节点
        loadOrganization() {
            this.$api.sysOrganization.selectOrganization().then(data => {
                this.items = data.data
                this.setChildShow(this.items);
            })
        },

        setChildShow(items) {
            for (let i in items) {
                if (items[i].children.length == 0) {
                    items[i].children = undefined
                } else {
                    this.setChildShow(items[i].children);
                }
            }
        },

        //取消绑定
        deleteItem(item) {
            const id = item.id;
            this.$dialog.confirm(this.$vuetify.lang.t('$vuetify.custom.cancelBind'), null, () => {
                this.$api.sysUserOrganization.deletorg({orgId: id}).then(data => {
                    this.selectOrg()
                })
            })
        },
        //根据树形节点查询关联的用户信息
        selectOrg(val) {
            if (val != undefined) {
                this.formData.id = val[0]
                this.orgId = this.formData.id;
            }
            this.$api.sysOrganization.selectOrgBingUser(
                this.orgId
            ).then(data => {
                if (data.flag) {
                    this.desserts = data.data;
                } else {
                    this.$dialog.alert(data.msg);
                }
            })
        }
    },
    components: {
        IconSelector,
        ETree,
        userBinddialog
    },
}
</script>
